<template>
  <rc-customer-signup></rc-customer-signup>
</template>

<script>
import RcCustomerSignup from "@/redcrm/components/customer/customer-signup/RcCustomerSignup.vue";

export default {
  components: { RcCustomerSignup },
};
</script>

<style></style>
